import React from 'react';
import PopupMenu from '../PopupMenu';
import { render, screen } from '@testing-library/react';

describe('PopupMenu Component', () => {
  it('it renders its children', () => {
    const links = ['1', '2', '3', '4', '5'];
    const anchorLinks = links.map((link, index) =>
      <a key={index}>{link}</a>
    );
    render(
      <PopupMenu>
        <div>
          {anchorLinks}
        </div>
      </PopupMenu>
    );
    links.forEach(link =>
      expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'a' && content === link))
        .toBeInTheDocument()
    );
  });
  it('it renders arrow if there is children', () => {
    render(
      <PopupMenu>
        <a>1</a>
      </PopupMenu>
    );
    expect(screen.getByTestId('popup-menu-arrow')).toBeInTheDocument();
  });
  it('it does not render arrow if there is no children', () => {
    render(<PopupMenu/>);
    expect(screen.queryByTestId('popup-menu-arrow')).not.toBeInTheDocument();
  });

});
